/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/13
 * Time: 10:40
 * Desc: 网点管理
 */

import { Component, Vue } from 'vue-property-decorator';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';
import NoAuth from '@/views/components/noAuth/noAuth.vue';
import { getImgToBase64 } from '@/util/base64-to-file';
import { noop } from '@/util';

@Component({
  components: {
    NoAuth,
  },
})
export default class SiteManage extends Vue {
  sgId: number = null;

  siteQRCodeVisible = false;

  /**
   * loading状态
   * @type {boolean}
   */
  public loadingState = true;

  /**
   * 网点列表
   * @type {Array<ItemObject>}
   */
  public sitesArray: Array<any> = [];

  /**
   * 关键字
   * @type {string}
   */
  public keyword = '';

  /**
   * 总条数
   * @type {number}
   */
  public pageTotal = 0;

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 10;

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = false;

  /**
   * 展示配置,黑白名单,预约试穿及出样,虚拟店长功能权限，编辑按钮是否显示
   * @type {boolean}
   */
  public isEditShow = false;

  // 预览的图片
  public imageView = '';
  // 预览图片数组
  public selectQRCode: exportSiteQRCode[] = null;

  // table selected column
  public tableSelected: any[] = [];

  /* 方法 */

  /**
   * 获得网点列表(API)
   * @return null
   */
  public getSiteList(): void {
    this.sitesArray = [];
    const postParams = {
      page: this.page,
      pageNum: this.pageSize,
      keywords: this.keyword,
    };
    IPSService.siteManager({ postParams }).then(
      (res) => {
        this.loadingState = false;
        this.pageTotal = res.count;
        // 格式化数据
        res.list.forEach((item) => {
          item.siteTel = Functions.emptyVaribleHandler(item.siteTel);
          item.siteAddress = Functions.emptyVaribleHandler(item.siteAddress);
        });
        this.sitesArray = res.list;
        this.sitesArray.map((item, index) => {
          item.id = (this.page - 1) * this.pageSize + index + 1;
        });
      },
      () => {
        this.loadingState = false;
      },
    );
  }

  /**
   * 去往网点信息页面
   * @return null
   */
  public onGoToEditSite(row): void {
    const { siteId, siteName, siteCode, sgId } = row;
    localStorage.setItem('siteId', siteId);
    this.sgId = siteId;
    this.$router.push(`/siteManage/site/${siteId}/${siteCode}/${sgId}/${row.isVirtual ? 2 : 1}/1/${row.isVirtual ? 0 : 1}`);
    this.$store.commit('onModifySiteName', siteName);
  }

  /**
   * 打开网点小程序码的弹窗
   * @param siteId
   * @param visible
   */
  openSiteBRCode(siteId, visible = true) {
    const postParams = {
      siteIds: siteId,
    };

    return IPSService.adminSiteQRCodeExport({ postParams }).then((response) => {
      this.imageView = response.list[0].siteQrcode;
      this.selectQRCode = response.list;
      this.siteQRCodeVisible = visible;
    });
  }

  // batch download mini images
  handleBatchDownloadImage() {
    const siteIds = this.tableSelected.map(i => i.siteId);
    this.openSiteBRCode(siteIds, false).then(() => {
      this.handleDownloadImage();
    });
  }

  // table selected event
  onHandleSelectionChange(selected: any[]) {
    this.tableSelected = selected;
  }

  // 关闭弹窗
  closeSiteBRCode() {
    this.siteQRCodeVisible = false;
    this.selectQRCode = [];
  }

  // 下载小程序码图片
  handleDownloadImage() {
    const zip = new JSZip();
    const list = this.selectQRCode || [];
    const promiseList = list.map((i) => {
      return getImgToBase64(i.siteQrcode);
    });
    Promise.all(promiseList).then((base64Arr) => {
      base64Arr.forEach((imgData, index) => {
        const img_arr = imgData.split(',');
        zip.file(`${list[index].qrName}.jpg`, img_arr[1], { base64: true });
      });

      zip.generateAsync({ type: 'blob' }).then((content) => {
        saveAs(content, '网点小程序码.zip');
      });
    });
  }

  /**
   * 搜索网点
   * @return null
   */
  public onSearchSite(): void {
    this.page = 1;
    this.pageSize = 10;
    this.getSiteList();
  }

  /**
   * 每页条数变更
   * @return null
   */
  public onHandleSizeChange(val): void {
    this.pageSize = val;
    this.getSiteList();
  }

  /**
   * 页码变更
   * @return null
   */
  public onHandleCurrentChange(val): void {
    this.page = val;
    this.getSiteList();
  }

  /* 周期 */

  /**
   * 当组建加载完成
   */
  public created() {
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-SITE');
    this.isEditShow
      = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-SITE-STOCK-CONFIG')
      || this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-SITE-DISPLAY-CONFIG')
      || this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-SITE-HIDDEN-CONFIG')
      || this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-SITE-APPLY-CONFIG')
      || this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-SITE-V-GUIDER-CONFIG');
    if (this.isContentBodyShow) {
      this.getSiteList(); // 获取网点列表
    }
  }
}
